import { ENV } from './config.js';

/**
 * GrphQL Query to Piers
 */
export default async function FetchUserInfo( companyId, personId, token ) {
    const response = await fetch( `https://${ ENV }api.biw.cloud/v1/piers/graphql`, {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            'authorization': `Bearer ${ token }`
        },
        body: JSON.stringify(
            {
                query: `query($companyId: String!, $personId: String!) {
                    person(companyId: $companyId, personId: $personId) {
                        asOf
                        cashier {
                            points
                            tokens {
                                id
                                roomId
                                state
                            }
                            giftCodes {
                                giftCodeId
                                expiredAt
                                status
                                levelName
                                description
                            }
                        }
                        profile {
                            personId
                            givenName
                            surname
                            companyId
                            companyName
                            companyUrl
                            recoveryMethodsSet
                            avatar
                            locale
                        }
                        solutions {
                            solutionId
                            solutionIdentity
                            solutionName
                            primaryExperience
                            experiences {
                                id
                                name
                                identity
                                types
                                descriptions
                                url
                            }
                        }
                        companies {
                            id
                            name
                            identifierList
                            contactEmailAddress
                        }
                        marketplace {
                            menuItems {
                                displayOrder
                                pageType
                                colorLogo
                                outlineThickLogo
                            }
                        }
                    }
                }`,
                variables: {
                    companyId,
                    personId
                }
            }
        )
    } );

    const data = await response.json();
    return data;
}
